<template>
  <v-form ref="form" v-model="formIsValid" class="container">
    <v-row>
      <!-- First Name, Middle Name, and Last Name in the same row -->
      <v-col cols="12" sm="4">
        <v-text-field
          label="First Name *"
          v-model="personalInfo.firstName"
          variant="outlined"
          dense
          class="form-field"
          color="blue"
          hide-details="auto"
          :rules="[(v) => !!v || 'This field is required.']"
          required
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-account-circle-outline</v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Father's Name *"
          v-model="personalInfo.middleName"
          variant="outlined"
          dense
          :rules="[(v) => !!v || 'This field is required.']"
          required
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-account-circle-outline</v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Grandfather's Name *"
          v-model="personalInfo.lastName"
          variant="outlined"
          dense
          :rules="[(v) => !!v || 'This field is required.']"
          required
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-account-circle-outline</v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <!-- Gender, Date of Birth, and Place of Birth in the same row -->
      <v-col cols="12" sm="4">
        <v-select
          label="Gender *"
          :items="['Male', 'Female']"
          v-model="personalInfo.sex"
          variant="outlined"
          dense
          :rules="[(v) => !!v || 'This field is required.']"
          required
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-gender-male-female</v-icon>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Date of Birth *"
          type="date"
          v-model="personalInfo.dateOfBirth"
          variant="outlined"
          dense
          :rules="[(v) => !!v || 'This field is required.']"
          required
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-calendar</v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Place of Birth *"
          v-model="personalInfo.placeOfBirth"
          variant="outlined"
          dense
          
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-map-marker</v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <!-- Marital Status, Nationality, and Permanent Address in the same row -->
      <v-col cols="12" sm="4">
        <v-select
          label="Marital Status"
          v-model="personalInfo.maritalStatus"
          variant="outlined"
          :items="['Single', 'Married', 'Divorced', 'Widowed']"
          dense
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-heart</v-icon>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-input
          label="Nationality *"
          variant="outlined"
          dense
          class="form-field stylish-field"
          color="blue"
          hide-details="auto"
          :rules="[(v) => !!v || 'This field is required.']"
          v-model="personalInfo.nationality"

        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-earth</v-icon>
          </template>
          <country-select
            v-model="personalInfo.nationality"
            class="country-select-field"
            placeholder="Nationality *"

            :country="personalInfo.nationality"
            topCountry="ET"
            countryName="true"
          />
        </v-input>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Permanent Address *"
          v-model="personalInfo.permanentAddress"
          variant="outlined"
          dense
          :rules="[(v) => !!v || 'This field is required.']"
          required
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-home</v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <!-- Present Address and KSHS Entry Year in the last row -->
      <v-col cols="12" sm="4">
        <v-text-field
          label="Present Address *"
          v-model="personalInfo.presentAddress"
          variant="outlined"
          dense
          :rules="[(v) => !!v || 'This field is required.']"
          required
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-home-city</v-icon>
          </template>
        </v-text-field>
      </v-col>
      <!-- <v-col cols="12" sm="4">
        <v-text-field
          label="KSHS Entry Year(E.C)"
          v-model="personalInfo.entryYear"
          type="number"
          variant="outlined"
          dense
          :rules="[(v) => !!v || 'This field is required.']"
          required
          class="form-field"
          color="blue"
          hide-details="auto"
        > -->
          <!-- <template v-slot:prepend>
            <v-icon color="red">mdi-home-city</v-icon>
          </template>
        </v-text-field>
      </v-col> -->
    </v-row>
  </v-form>
</template>

<script>
import { CountrySelect } from 'vue3-country-region-select';

export default {
  components: { CountrySelect },
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      personalInfo: { ...this.formData }, // Initialize the local data with the passed prop
      formIsValid: false, // Ensure form validity is tracked
    };
  },

  methods:{
    
    async validateForm() {
      const isValid = await this.$refs.form.validate();
      console.log(isValid.valid ? 'All fields are valid.' : 'Validation failed.');
    
      return isValid.valid;
      // return true;
    },

  },
  watch: {
    userPersonalInfo: {
      handler(newData) {
        this.personalInfo = { ...newData }; // Update personalInfo when userPersonalInfo changes
      },
      immediate: true, // Ensure the handler is called immediately
      deep: true,
    },
    personalInfo: {
      handler(newData) {
        this.$emit('update-form-data', newData); // Emit the updated data back to parent
      },
      deep: true,
    },
  },
  computed: {
    userPersonalInfo() {
      return this.$store.getters.user.personalInfo;
    },
  },

  mounted() {
    // Initialize personalInfo with the data from the computed property
    this.personalInfo = { ...this.userPersonalInfo };
  },


};
</script>

<style scoped>
.stylish-field {
  background-color: #f9f9f9;
  padding: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stylish-field:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 15px rgba(54, 202, 222, 0.4);
}

.country-select-field {
  border: 1px solid rgba(0, 0, 0, 0.397);
  border-radius: 3px;
  width: 100%;
  height: 40px;
  background: transparent;
  padding: 0;
  font-size: 1rem;
  color: #495057;
}

.container {
  max-width: 1000px;
  margin: 30px auto;
  padding: 20px;
  background: linear-gradient(135deg, #f0f4f8, #d9e2ec);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border: 1px solid #e1e7ef;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  position: relative;
}

.container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
  animation: rotate-bg 8s linear infinite;
  z-index: 0;
}

.container:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.container > * {
  position: relative;
  z-index: 1;
}

@keyframes rotate-bg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.form-field {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(231, 183, 179, 0.778);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.form-field:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 15px rgba(109, 191, 46, 0.77);
}

.v-text-field input {
  font-size: 1rem;
  font-weight: 500;
}

.v-select .v-select__selections {
  font-size: 1rem;
  font-weight: 500;
}

.v-form .v-input__control {
  border-radius: 8px;
}

.v-text-field.v-text-field--outlined {
  background-color: #ffffff;
  border-radius: 12px;
}

.v-text-field .v-input__append-inner {
  padding-right: 15px;
}

.v-text-field .v-input__prepend-inner {
  padding-left: 15px;
}

.v-select .v-select__selections {
  font-size: 1rem;
  font-weight: 500;
}

.v-btn {
  background-color: #6200ea;
  color: white;
  padding: 12px 20px;
  border-radius: 50px;
  box-shadow: 0 4px 10px rgb(242, 12, 12);
  transition: background-color 0.3s ease;
}

.v-btn:hover {
  background-color: #3700b3;
}

.red-icon {
  color: red !important;
}
</style>